import { Grid, FormControl, MenuItem, TextField, Button, Container, Skeleton, Paper, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CardsReport from '../../components/platform-report/CardsReport';
import './platform.css'
import { useSelector, useDispatch } from 'react-redux';
import { getAllCampaignsReport } from '../../redux/actions/platformReport';
import DateRangePicker from '../../components/dateTimePicker/CalenderForReport';
import ReportChart from '../../components/platform-report/ReportGraphs/ReportGraphs';
import Loader from '../../components/loader/Loader';
import axios from 'axios';
import { platformSummary } from '../../redux/actions/reportSummary.action';
import { PLATFORM_REPORT_BRAND_LOADED, platformBrand } from '../../redux/actions/reportBrand.action';
import { getAllVoucherBatch } from '../../redux/actions/voucher.actions';
import { getAllSourceBusiness, getAllSourceBusinessV3 } from '../../redux/actions/sourceBusiness.actions';
import Table from '../offers/Table';
// import PlatFormTable from './platFormTable';
import _ from "lodash";
import { motion } from 'framer-motion';

const PlatFormSummary = () => {
    const [value, setValue] = useState("");
    const [report, setReport] = useState({
        brands: "",
        offerings: ""
    })
    const [updatedSource, setUpdatedSource] = useState([])
    const dispatch = useDispatch();
    const {
        campaigns,
        startDate,
        endDate,
        voucher,
        brandData,
        sourceBusinesses
    } = useSelector((state) => ({
        campaigns: state?.platformReportReducer?.campaigns,
        startDate: state?.DateDataStorage?.startDate,
        endDate: state?.DateDataStorage?.endDate,
        summary: state?.reportSummaryReducer?.summary,
        brandData: state?.reportBrandsReducer?.brands?.data,
        voucher: state?.voucherReducer?.voucherBatches,
        sourceBusinesses: state?.sourceBusinessReducer?.sourceBusinesses
    }));



    //show brands
    const BrandNames = useMemo(() => [
        { id: "", brand: "All" },
        ...(sourceBusinesses?.map((item) => ({
            id: item?.brand_id,
            brand: item?.brand_name
        })) || [])
    ], [sourceBusinesses, value]);


    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        dispatch(getAllCampaignsReport())
    }, [])


    const handleChange = (event) => {
        dispatch({
            type: PLATFORM_REPORT_BRAND_LOADED,
            payload: null
        })
        setReport({
            brands: "",
            offerings: ""
        })
        setValue(event.target.value);
    };

    const [error, setError] = useState("")
    const handleReportPlatform = async () => {
        if (!value) return;
        const reportDomain = process.env.REACT_APP_BASE_REPORT_PLATFORM;
        setIsLoading(true);


        try {
            let brandUrl = `${reportDomain}brand?startDate=${startDate}&endDate=${endDate}&isAll=true`;// brand

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            if (value !== "all") {
                if (report?.brands?.id) {
                    brandUrl += `&campaign_id=${value}&brand_id=${report.brands.id}`;

                    if (report?.offerings && report.offerings !== "All") {
                        brandUrl += `&offering_id=${report.offerings}`;
                    }
                } else {
                    brandUrl += `&campaign_id=${value}`;
                }
            } else if (value === "all") {
                if (report?.brands?.id) {
                    brandUrl += `&brand_id=${report.brands.id}`;

                    if (report?.offerings && report.offerings !== "All") {
                        brandUrl += `&offering_id=${report.offerings}`;
                    }
                }
            }
            const [brandResponse] = await Promise.all([
                axios.get(brandUrl,config)
            ]);

            setIsLoading(false);

            if (brandResponse.data) {
                dispatch(platformBrand(brandResponse?.data?.data));
            }
        } catch (error) {
            setIsLoading(false);
            setError(error?.response?.data?.message)
            setReport({
                brands: "",
                offerings: ""
            })
        }
    };



    useEffect(() => {
        if (value) {
            dispatch(getAllSourceBusiness());
            dispatch(getAllVoucherBatch());
        }
    }, [dispatch, value])

    const handleReportChange = (value, index) => {
        dispatch({
            type: PLATFORM_REPORT_BRAND_LOADED,
            payload: null
        })
        setReport(prev => {
            const newReport = { ...prev };
            if (index === 0) {
                newReport.brands = value;
                newReport.offerings = ""
            } else if (index === 1) {
                newReport.offerings = value;
            }
            return newReport;
        });
    };


    useEffect(() => {
        if (report?.brands && voucher) {
            const sourceOld = voucher?.filter(
                (item) => item?.brand_id === report?.brands?.id
            );
            setUpdatedSource([{ offering_id: "All", brand_name: "All" }, ...sourceOld])
        }
    }, [report]);


    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError(null);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [error]);


    const columns = [
        { field: "brandName", headerName: "Brand Name", flex: 1 },
        { field: "consumptionCount", headerName: "Consumption Count", width: 180 },
    ]


    const rows = brandData?.data?.length > 0 ? brandData?.data?.map((item, index) => ({
        id: index + 1, // Assigning a unique ID
        brandName: item?.brandName?.trim(), // Trim spaces for better formatting
        consumptionCount: item?.consumptionCount,
    })) : "";



    console.log(campaigns,"campaigns")



    return (
        <Container className="platform-summary-management">
            {error ? <p style={{ color: 'red' }}>error</p> : ""}
            <motion.div
                className="platform-summary-intro"
                initial={{ opacity: 0, y: -16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut" }}
            >
                <h2>Platform Campaign Summary Overview</h2>
                <p>
                    Select campaign, brand, offering, and date range to generate summary-level platform report insights.
                </p>
            </motion.div>
            <Grid container item direction="row" columnSpacing={2} >
                <Grid container item direction="column" spacing={1} xs={3}>
                    <FormControl fullWidth>
                        <TextField
                            select
                            label="Select Your Campaigns"
                            value={value || ""}
                            onChange={handleChange}
                            fullWidth
                        >
                            {campaigns?.length > 0 ? (
                                campaigns.map((item, index) => (
                                    <MenuItem key={index} value={item?.campaign_id}>
                                        {` ${item?.title} [${item?.campaign_id}]`}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No campaigns available</MenuItem>
                            )}
                        </TextField>
                    </FormControl>
                </Grid>
                <Grid container item direction='column' spacing={1} xs={3}>
                    {
                        (value) ? <FormControl fullWidth>
                            <TextField
                                select
                                label="Select Your Brand"
                                value={report?.brands?.brand ? report?.brands?.brand : "All"}
                                onChange={(e) => {
                                    const selectedBrand = BrandNames.find((item) => item.brand === e.target.value);
                                    handleReportChange({ id: selectedBrand?.id, brand: selectedBrand?.brand }, 0);
                                }}
                                fullWidth
                            >
                                {BrandNames?.length > 0 ? (
                                    BrandNames.map((item, index) => (
                                        <MenuItem key={index} value={item.brand} >
                                            {item?.brand}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No campaigns available</MenuItem>
                                )}
                            </TextField>
                        </FormControl>
                            : ""
                    }
                </Grid>
                <Grid container item direction='column' spacing={1} xs={3}>
                    {
                        (report?.brands?.brand && (report?.brands?.id !== "")) ? <FormControl fullWidth>
                            <TextField
                                select
                                label="Select Your Offering"
                                value={report?.offerings || "All"}
                                onChange={(e) => handleReportChange(e.target.value, 1)}
                                fullWidth
                            >
                                {updatedSource?.length > 0 ? (
                                    updatedSource.map((item, index) => (
                                        <MenuItem key={index} value={item.offering_id}>
                                            {`${item?.offering_id} and ${item?.brand_name}`}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No campaigns available</MenuItem>
                                )}
                            </TextField>
                        </FormControl>
                            : ""
                    }
                </Grid>
            </Grid>
            <Grid container item direction="row" columnSpacing={2} mt={4} justifyContent={`center`}>
                <Grid container item direction='column' spacing={1} xs={6}>
                    {value ? <DateRangePicker /> : ""}
                </Grid>
            </Grid>
            <div className='button_center'>
                <Button onClick={handleReportPlatform} disabled={!value}
                    sx={{
                        background: 'linear-gradient(135deg, #ffffff 30%, #f0f0f0 90%)',
                        color: '#2f2b3de6',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
                        padding: '0.5rem 1rem',
                        fontSize: "15px",
                        transition: 'all 0.3s ease',
                        marginBottom: '20px',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #f0f0f0 30%, #e0e0e0 90%)',
                            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >Get Campaigns Report</Button>
            </div>
            <div className='donut-chart'>
                {
                    isLoading ?
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="70vh"
                            animation="wave"
                            sx={{ borderRadius: '12px' }}
                        />
                        :
                        <>
                            <Grid container direction="row" item xs={12} spacing={1}>
                                <Grid item xs={12} width={`100%`}>
                                    {
                                        brandData?.data?.length > 0 ? <Table rows={rows} columns={columns} idVisible={false} /> :
                                            <Paper
                                                elevation={3}
                                                sx={{
                                                    padding: '2rem',
                                                    textAlign: 'center',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '12px',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                }}
                                            >
                                                <Typography variant="h6" color="textSecondary">
                                                    🚫 No data available for the selected criteria. Please Select Campagins
                                                </Typography>
                                            </Paper>
                                    }

                                </Grid>
                            </Grid>
                        </>
                }
            </div>
        </Container>
    );
};

export default PlatFormSummary;
